import { Component } from '@angular/core';

@Component({
  selector: 'active-records-skeleton',
  templateUrl: './active-records-skeleton.component.html',
  styleUrls: ['./active-records-skeleton.component.scss'],
})
export class ActiveRecordsSkeletonComponent {}
